module.exports = __webpack_public_path__ + "static/media/hands-mob.e7b83d72.jpg";